// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ae0e18d5","855":"a48d40f5"}[chunkId] + ".chunk.js";
};